import Image from "next/image";
import blackChevron from "@/assets/icons/blackChevron.svg";

export const CheckValueSell = () => {
  return (
    <div className="CVS">
      <div className="VTS-item">
        <div className="VTS-title-wrapper">
          <Image
            src={blackChevron}
            alt=""
            aria-hidden="true"
            className="black-chevron"
            width={32}
            height={32}
          />
          <h2>Überprüfen</h2>
        </div>
        <p>Kostenlosen Bericht zur Fahrgestellnummer erhalten</p>
      </div>
      <div className="VTS-item">
        <div className="VTS-title-wrapper">
          <Image
            src={blackChevron}
            alt=""
            aria-hidden="true"
            className="black-chevron"
            width={32}
            height={32}
          />
          <h2>Bewerten</h2>
        </div>
        <p>Basierend auf die Daten eine Marktwertanalyse erhalten</p>
      </div>
      <div className="VTS-item">
        <div className="VTS-title-wrapper">
          <Image
            src={blackChevron}
            alt=""
            aria-hidden="true"
            className="black-chevron"
            width={32}
            height={32}
          />
          <h2>Verfolgen</h2>
        </div>
        <p>Erhalte monatliche Updates zur Wertentwicklung</p>
      </div>
    </div>
  );
};
